import type { FC, ReactNode } from 'react'

import { useMemo } from 'react'
import { PixelSprite } from '@/components/pixel/pixel-sprite'

import { FLOWER } from '@/constants/sprites'

interface PixelFlowerProps {
    className?: string
    color?: string
    centerColor?: string
}

const PixelFlower: FC<PixelFlowerProps> = ({
    className,
    color = 'var(--fern)',
    centerColor
}): ReactNode => {
    const palette = useMemo(() => ({ O: color, C: centerColor ?? color }), [color, centerColor])

    return <PixelSprite rows={FLOWER} palette={palette} className={className} />
}

export default PixelFlower
